import React from 'react'
import {useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router';
import {ROUTES} from '../../db/models/const';
import {openAlert} from '../../slices/alert';
import {closeDialog} from '../../slices/dialog';
import {addDemo} from '../../api/other';
import Button from '../Common/Button';
import "./RequestDemo.scss";

export const RequestDemo = () => {
    const {register, handleSubmit, errors} = useForm({
        defaultValues: {
            iam: "",
            name: "",
            company: "",
            role: "",
            email: "",
            message: "",
            privacy: false
        }
    });
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const history = useHistory();

    const onSave = async (form) => {
        const data = {
            iam: form.iam,
            name: form.name,
            company: form.company,
            role: form.role,
            email: form.email,
            message: form.message,
        };

        addDemo(data).then(() => {
            dispatch(openAlert({type: "success", message: t("alert_demo_thanks")}))
            dispatch(closeDialog());
        })
            .catch(error => {
                dispatch(openAlert({type: "error", message: t("alert_generic_error")}));
            });
    }

    const openPrivacy = () => {
        window.open("/privacy", '_blank', 'noopener');
    }

    const handleGoTo = (path) => {
        history.push(path);
    };

    return (
        <section className="requestDemo container">
            <h2>{t("signup_company_title")}</h2>
            <div className="requestDemo__changeRole">
                <button onClick={() => handleGoTo(ROUTES.SIGNUP_STUDENT)}>
                    Studente
                </button>
                <button
                    className="active"
                    onClick={() => handleGoTo(ROUTES.SIGNUP_COMPANY)}
                >
                    Azienda
                </button>
            </div>
            <form onSubmit={handleSubmit(onSave)}>
                <div className="element">
                    <div className="label">{t("demo_iam_label")}<span className="asterisk">*</span></div>
                    <select
                        name="iam"
                        ref={register({required: true})}
                    >
                        <option value={""}>{t("demo_iam_op0")}</option>
                        <option key={t("demo_iam_op1")} value={t("demo_iam_op1")}>{t("demo_iam_op1")}</option>
                        <option key={t("demo_iam_op2")} value={t("demo_iam_op2")}>{t("demo_iam_op2")}</option>
                        <option key={t("demo_iam_op3")} value={t("demo_iam_op3")}>{t("demo_iam_op3")}</option>
                        <option key={t("demo_iam_op4")} value={t("demo_iam_op4")}>{t("demo_iam_op4")}</option>
                        <option key={t("demo_iam_op5")} value={t("demo_iam_op5")}>{t("demo_iam_op5")}</option>
                    </select>
                    {errors.iam && <p className="error">{t("demo_iam_error")}</p>}
                </div>
                <div className="element">
                    <div className="label">{t("demo_name_label")}<span className="asterisk">*</span></div>
                    <input
                        name="name"
                        type="text"
                        placeholder={t("demo_name_ph")}
                        ref={register({required: true})}
                    />
                    {errors.name && <p className="error">{t("demo_name_error")}</p>}
                </div>
                <div className="element">
                    <div className="label">{t("demo_company_label")}<span className="asterisk">*</span></div>
                    <input
                        name="company"
                        type="text"
                        placeholder={t("demo_company_ph")}
                        ref={register()}
                    />
                </div>
                <div className="element">
                    <div className="label">{t("demo_ruolo_label")}<span className="asterisk">*</span></div>
                    <input
                        name="role"
                        type="text"
                        placeholder={t("demo_ruolo_ph")}
                        ref={register()}
                    />
                </div>
                <div className="element">
                    <div className="label">{t("demo_email_label")}<span className="asterisk">*</span></div>
                    <input
                        name="email"
                        type="email"
                        placeholder={t("demo_email_ph")}
                        ref={register({required: true})}
                    />
                    {errors.email && <p className="error">{t("demo_email_error")}</p>}
                </div>
                <div className="element">
                    <div className="label">{t("demo_message_label")}</div>
                    <textarea
                        name="message"
                        placeholder={t("demo_message_ph")}
                        ref={register()}
                        rows="5"
                    />
                </div>
                <div className="element">
                    <div className="checkbox">
                        <input type="checkbox" name="privacy" ref={register({required: true})}/>
                        <p>{t("demo_privacy_text") + " "}<span className="link"
                                                               onClick={openPrivacy}>{t("demo_privacy_link")}</span></p>
                    </div>
                    {errors.privacy && <p className="error">{t("demo_privacy_error")}</p>}
                </div>
                <Button type="submit">{t("demo_button")}</Button>
            </form>
        </section>
    )
}
